import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CupraBudgetModel } from '../../../models/cuprabudget';
import { CupraBudgetService } from '../../../services/budget.service';
import { environment } from 'src/environments/environment';
import { CupraCalculatorService } from '../../../services/cupracalculator.service';
import { CupraOperationModel } from '../../../models/cupraoperation';
import { CupraBudgetOperationModel } from 'src/app/models/cuprabudgetoperation';
import * as $ from 'jquery';
import { CupraBudgetOperationService } from 'src/app/services/cuprabudgetoperation';
import { Status } from 'src/app/models/enums';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OperationModalComponent } from './operation-modal/operation-modal.component';
import { PiezaDesgasteModel } from '../../../models/pieza-desgaste';
import { PiezaDesgasteModalComponent } from './pieza-desgaste-modal/pieza-desgaste-modal.component';
import { CupraBudgetPiezaDesgasteService } from '../../../services/cuprabudgetpiezadesgaste.service';
import { PiezaDesgasteCalculationModel } from '../../../models/pieza-desgaste-calculation';

@Component({
  templateUrl: './budget-preview.component.html',
  styleUrls: ['./budget-preview.component.scss']
})

export class BudgetPreviewComponent implements OnInit, AfterViewChecked {

  idBudget: string;
  model: CupraBudgetModel;
  piezasModel: PiezaDesgasteCalculationModel[] = [];
  operationsModel: CupraOperationModel[];
  pathServer = environment.urlServer;
  mantenimientoSelected = false;
  email: string;
  showCupraCare = false;
  showValidationEmailError = false;
  showValidationOperationError = false;

  sendingEmailBudget = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private cupraBudgetService: CupraBudgetService,
    private cupraBudgetOperationService: CupraBudgetOperationService,
    private cupraBudgetPiezaDesgasteService: CupraBudgetPiezaDesgasteService,
    private toastr: ToastrService,
    private calculatorService: CupraCalculatorService,
    private modalService: NgbModal,
    private changeRef: ChangeDetectorRef) { }

  ngAfterViewChecked(): void { this.changeRef.detectChanges(); }

  ngOnInit() {

    this.idBudget = this.route.snapshot.paramMap.get('id');
    if (this.idBudget != null) {
      this.getBudget();
      this.getPiezasDesgaste();

      setTimeout(() => {
        this.setExistingBudget();
      }, 2000);
    }

  }

  getBudget() {
    this.cupraBudgetService.get(this.idBudget).subscribe(resp => {
      this.model = resp;
      // TODO: ocultado CUPRA CARE TEMPORALMENTE a petición de cuentas
      // this.showCupraCare = this.model.ShowCupraCare;
      if (this.model == null || this.model.IdVersion == null || this.model.IdProvince == null || this.model.Km == null || this.model.Months == null) {
        Swal.fire({
          toast: true,
          showConfirmButton: false,
          icon: 'error',
          title: '',
          text: 'Presupuesto inválido'
        });
        this.router.navigate(['/home']);
      }
      else {
        this.getBudgetCalculation();
      }
    }, (err) => {
      Swal.fire({
        toast: true,
        showConfirmButton: false,
        icon: 'error',
        title: '',
        text: 'Error al recuperar los datos'
      });
    });
  }

  getPiezasDesgaste() {
    const that = this;
    this.calculatorService.getPiezaDesgasteFromBudget(this.idBudget).subscribe(resp => {
      this.piezasModel = resp;      
      this.piezasModel.forEach(function (pieza) {
        pieza.CupraPiezaDesgasteOptions[0].Included = true;
        that.UpdatePiezaOptionData(pieza);
      });
    }, (err) => {
      Swal.fire({
        toast: true,
        showConfirmButton: false,
        icon: 'error',
        title: '',
        text: 'Error al recuperar los datos'
      });
    });
  }

  getBudgetCalculation() {
    const that = this;
    Swal.fire({
      toast: true,
      showConfirmButton: false,
      icon: 'info',
      title: 'Recuperando información',
      text: ''
    });
    Swal.showLoading();
    this.calculatorService.getCalculationFromBudget(this.model.IdBudget).subscribe(resp => {
      this.operationsModel = resp;

      if (this.model.FirstTime) {
        this.model.FirstTime = false;
        this.operationsModel.forEach(function (op) {
          that.SelectMantenimiento(op);
        });
      }

      Swal.close();
    }, (err) => {
      Swal.fire({
        toast: true,
        showConfirmButton: false,
        icon: 'error',
        title: '',
        text: 'Error al recuperar los datos'
      });
    });
  }

  openOperationModal(operation: CupraOperationModel) {
    const modalRef = this.modalService.open(OperationModalComponent, { size: 'lg' });
    this.SelectMantenimiento(operation);
    modalRef.componentInstance.operation = operation;
    modalRef.result.then((result) => {
      if (result) {
        this.SelectMantenimiento(result);
      }
    }, (reason) => {

    });
  }

  openPiezaModal(pieza: PiezaDesgasteCalculationModel) {
    var piezaModal = Object.assign({}, pieza);
    const modalRef = this.modalService.open(PiezaDesgasteModalComponent, { size: 'lg' });
    this.SelectPieza(pieza);
    modalRef.componentInstance.pieza = piezaModal;
    modalRef.result.then((result: PiezaDesgasteCalculationModel) => {

      var dataPieza = this.piezasModel.find(x => x.PiezaCode == result.PiezaCode);
      this.piezasModel[this.piezasModel.indexOf(dataPieza)] = result;

      if (result) {
        if (result.Included && this.model.BudgetPiezaDesgaste.find(o => o.PiezaCode == result.PiezaCode) != null) {
          let removeOp = this.model.BudgetPiezaDesgaste.find(o => o.PiezaCode == result.PiezaCode);
          this.model.BudgetPiezaDesgaste.splice(this.model.BudgetPiezaDesgaste.indexOf(removeOp), 1);
        }
        this.SelectPieza(result);
      }
    }, (reason) => {

    });
  }

  SelectMantenimiento(operation: CupraOperationModel) {

    if (this.model.BudgetOperations.find(o => o.OperationCode == operation.OperationCode) == null) {
      operation.Included = true;
      this.model.BudgetOperations.push({
        IdBudgetOperation: "",
        IdBudget: this.idBudget,
        IdOperation: operation.IdOperation,
        OperationCode: operation.OperationCode,
        Operation: operation.Operation,
        FinalPrice: operation.FinalPrice
      });

    } else {
      operation.Included = false;
      let removeOp = this.model.BudgetOperations.find(o => o.OperationCode == operation.OperationCode);
      this.model.BudgetOperations.splice(this.model.BudgetOperations.indexOf(removeOp), 1);
    }

    this.model.BudgetOperations = this.model.BudgetOperations.sort(function (x, y) {
      let a = x.OperationCode.toUpperCase(),
        b = y.OperationCode.toUpperCase();
      return a == b ? 0 : a > b ? 1 : -1;
    });

    this.CalculateBudgetPrice();
  }

  SelectPieza(pieza: PiezaDesgasteCalculationModel) {
    if (this.model.BudgetPiezaDesgaste.find(o => o.PiezaCode == pieza.PiezaCode) == null) {
      pieza.Included = true;
      this.model.BudgetPiezaDesgaste.push({
        IdBudgetPieza: "",
        IdBudget: this.idBudget,
        IdPieza: pieza.IdPieza,
        IdOption: pieza.CupraPiezaDesgasteOptions.find(x => x.Included).IdOption,
        Pieza: pieza.Description,
        PiezaCode: pieza.PiezaCode,
        Option: pieza.CupraPiezaDesgasteOptions.find(x => x.Included).Description,
        OptionCode: pieza.CupraPiezaDesgasteOptions.find(x => x.Included).OptionCode,
        FinalPrice: pieza.CupraPiezaDesgasteOptions.find(x => x.Included).FinalPrice,
        ShowOption: pieza.CupraPiezaDesgasteOptions.length > 1
      });

    } else {
      pieza.Included = false;
      let removeOp = this.model.BudgetPiezaDesgaste.find(o => o.PiezaCode == pieza.PiezaCode);
      this.model.BudgetPiezaDesgaste.splice(this.model.BudgetPiezaDesgaste.indexOf(removeOp), 1);
    }

    this.model.BudgetPiezaDesgaste = this.model.BudgetPiezaDesgaste.sort(function (x, y) {
      let a = x.PiezaCode.toUpperCase(),
        b = y.PiezaCode.toUpperCase();
      return a == b ? 0 : a > b ? 1 : -1;
    });

    this.CalculateBudgetPrice();
  }

  UpdatePiezaOptionData(pieza: PiezaDesgasteCalculationModel) {
    pieza.SelectedOptionDesc = pieza.CupraPiezaDesgasteOptions.find(x => x.Included).Description;
    pieza.SelectedOptionPrice = pieza.CupraPiezaDesgasteOptions.find(x => x.Included).FinalPrice;
  }

  CalculateBudgetPrice() {

    const that = this;
    this.model.BudgetPrice = 0;
    this.model.BudgetOperations.forEach(function (op) {
      let oper = that.operationsModel.find(o => o.OperationCode == op.OperationCode);
      if (oper != null && oper !== undefined)
        that.model.BudgetPrice += oper.FinalPrice;
    });

    this.model.BudgetPiezaDesgaste.forEach(function (pieza) {
      let pz = that.piezasModel.find(o => o.PiezaCode == pieza.PiezaCode);
      if (pz != null && pz !== undefined)
        that.model.BudgetPrice += pz.SelectedOptionPrice;
    });
  }

  sendBudget(pdf?, gotoCita?) {

    if (this.model.BudgetOperations.length > 0 || this.model.BudgetPiezaDesgaste.length > 0) {

      this.showValidationOperationError = false;

      this.cupraBudgetOperationService.post(this.idBudget, this.model.BudgetOperations).subscribe(() => {

        this.cupraBudgetPiezaDesgasteService.post(this.idBudget, this.model.BudgetPiezaDesgaste).subscribe(() => {

          this.model.IdStatus = Status.Creado;
          this.cupraBudgetService.put(this.model.IdBudget, this.model).subscribe(res => {

            if (pdf)
              this.getPdf();
            else if (gotoCita)
              this.router.navigate(['/cupra-date/' + this.idBudget]);
            else
              this.sendMail();

          }, (err) => {
            Swal.fire({
              toast: true,
              showConfirmButton: false,
              icon: 'error',
              title: '',
              text: 'Error al crear el presupuesto'
            });
          });

        }, (err) => {
          Swal.fire({
            toast: true,
            showConfirmButton: false,
            icon: 'error',
            title: '',
            text: 'Error al crear el presupuesto'
          });
        });

      }, (err) => {
        Swal.fire({
          toast: true,
          showConfirmButton: false,
          icon: 'error',
          title: '',
          text: 'Error al crear el presupuesto'
        });
      });
    }
    else {
      this.showValidationOperationError = true;
    }
  }

  getPdf() {

    Swal.fire({
      toast: true,
      icon: 'info',
      showConfirmButton: false,
      title: 'Generando PDF',
      text: ''
    });
    Swal.showLoading();

    this.cupraBudgetService.GetPdf(this.model.IdBudget).subscribe(fileDoc => {

      saveAs(fileDoc, "Presupuesto " + this.model.BudgetCode);
      Swal.close();

    }, (err) => {
      Swal.fire({
        toast: true,
        showConfirmButton: false,
        icon: 'error',
        title: '',
        text: 'Error al crear el presupuesto'
      });
    });
  }

  sendMail() {

    const mailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


    if (mailRegex.test(this.email)) {

      this.sendingEmailBudget = true;
      this.showValidationEmailError = false;

      Swal.fire({
        toast: true,
        showConfirmButton: false,
        icon: 'info',
        title: 'Enviando Email',
        text: ''
      });
      Swal.showLoading();

      this.cupraBudgetService.SendMail(this.model.IdBudget, this.email).subscribe(fileDoc => {

        Swal.close();
        this.toastr.success("El presupuesto se ha enviado a la dirección de email indicada");

        setTimeout(() => {
          this.sendingEmailBudget = false;
        }, 60000);

      }, (err) => {
        Swal.fire({
          toast: true,
          showConfirmButton: false,
          icon: 'error',
          title: '',
          text: 'Error al crear el presupuesto'
        });
      });
    } else {
      this.showValidationEmailError = true;
    }

  }

  setExistingBudget() {

    this.operationsModel.forEach(function (op) {
      op.Included = false;
    });

    this.model.BudgetOperations = this.model.BudgetOperations.sort(function (x, y) {
      let a = x.OperationCode.toUpperCase(),
        b = y.OperationCode.toUpperCase();
      return a == b ? 0 : a > b ? 1 : -1;
    });

    this.model.BudgetOperations.forEach(elem => {
      var op = this.operationsModel.find(o => o.OperationCode == elem.OperationCode);
      if (op != null) {
        op.Included = true;
      }
    });

    this.model.BudgetPiezaDesgaste.forEach(elem => {
      var pieza = this.piezasModel.find(o => o.PiezaCode == elem.PiezaCode);
      if (pieza != null) {
        pieza.CupraPiezaDesgasteOptions = pieza.CupraPiezaDesgasteOptions.map(({ Included, ...rest }) => ({ ...rest, Included: false }));
        pieza.Included = true;
        //elem.Pieza = pieza.Description;
        var option = pieza.CupraPiezaDesgasteOptions.find(x => x.OptionCode == elem.OptionCode);
        if (option != null) {
          option.Included = true;
          //elem.Option = option.Description;
          pieza.SelectedOptionDesc = elem.Option;
          pieza.SelectedOptionPrice = elem.FinalPrice;
          //elem.ShowOption = pieza.Options.length > 1
        }
      }
    });

  }

}
